module.exports = __webpack_public_path__ + "img/gold-easter-egg.abaaf617.jpg";